import { useRef, type ReactNode } from 'react';
import { cx } from '../design/primitives.tsx';
import { useEdgeFade } from './EdgeFade.ts';

/** A box that scrolls sideways (a wide table) and fades the edge where more is hidden. */
export function ScrollX({ className, children }: { className?: string; children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  const onScroll = useEdgeFade(ref);
  return <div ref={ref} onScroll={onScroll} className={cx('edge-fade overflow-x-auto', className)}>{children}</div>;
}
